import { render, staticRenderFns } from "./table_body.vue?vue&type=template&id=39d7b604&lang=pug"
import script from "./table_body.vue?vue&type=script&lang=js"
export * from "./table_body.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports